/** Noms des settings shop (table `settings`) pour activer / désactiver des modules dans le menu. */
export const MODULE_SETTING = {
  /** Caisse POS (Polisi) */
  polisi: 'module_polisi_enabled',
  /** Comptabilité : dépenses, rapprochement (Logistiki) */
  logistiki: 'module_logistiki_enabled',
} as const;
